// extracted by mini-css-extract-plugin
module.exports = {"spacer":"MenuItemImage__spacer___1sS7t","image":"MenuItemImage__image___MHZTP","outOfStock":"MenuItemImage__outOfStock___1UKnO"};